"use client"

import { useEffect } from "react"
import NextError from "next/error"
import * as Sentry from "@sentry/nextjs"
import '@/instrumentation-client'

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {

    useEffect(() => {
        Sentry.captureException(error)
    }, [error])

    return (
        <html>
            <body>
                <NextError statusCode={0} />
            </body>
        </html>
    )
}